import { useQuery } from "react-query";
import axios from "infra/http";
import { HistoricoCobrancaFindItemResponse } from './../typings/index';


function useHistoricoCobrancaItem(id?: string) {
  return useQuery(
    [`/v1/historico-cobranca/${id}`],
    async () => {
      const res = await axios.get<HistoricoCobrancaFindItemResponse>(`/v1/historico-cobranca/${id}`, {
      });

      return res.data;
    },
    {enabled: !!id}
  );
}

export default useHistoricoCobrancaItem;
